var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFollowPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: 60,
    height: 60,
    preserveAspectRatio: "xMidYMid slice",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,30,30)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,43,84)",
    fillOpacity: 1,
    d: " M24,0 C24,13.255000114440918 13.255000114440918,24 0,24 C-13.255000114440918,24 -24,13.255000114440918 -24,0 C-24,-13.255000114440918 -13.255000114440918,-24 0,-24 C13.255000114440918,-24 24,-13.255000114440918 24,0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(255,43,84)",
    strokeOpacity: 1,
    strokeWidth: 0,
    d: " M24,0 C24,13.255000114440918 13.255000114440918,24 0,24 C-13.255000114440918,24 -24,13.255000114440918 -24,0 C-24,-13.255000114440918 -13.255000114440918,-24 0,-24 C13.255000114440918,-24 24,-13.255000114440918 24,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,30,30.125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,43,84)",
    fillOpacity: 1,
    d: " M0,-9 C0,-9 0,9 0,9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M0,-9 C0,-9 0,9 0,9"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,30,30.125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0.9297400116920471,0,0,1.0041899681091309,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-0.125,-9 C-0.125,-9 -0.125,9 -0.125,9"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-0.125,-9 C-0.125,-9 -0.125,9 -0.125,9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M0.06199999898672104,0.06199999898672104"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowPlus);
export default __webpack_public_path__ + "static/media/followPlus.37839b232df1220d0fb02dd57f6bd925.svg";
export { ForwardRef as ReactComponent };